
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_3bgfn_im8v7_5"
};
  